import { render, staticRenderFns } from "./ProductDeliveryByOrder.vue?vue&type=template&id=1ca27e16"
import script from "./ProductDeliveryByOrder.vue?vue&type=script&lang=js"
export * from "./ProductDeliveryByOrder.vue?vue&type=script&lang=js"
import style0 from "./ProductDeliveryByOrder.vue?vue&type=style&index=0&id=1ca27e16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports